import payment from './payment'
import signup from './signup'
import business from './business'
import plans from './plans'
import users from './users'
import verifications from './verifications'
import wholesalers from './wholesalers'
import malls from './malls'

export default {
  ...signup,
  ...payment,
  ...business,
  ...plans,
  ...users,
  ...verifications,
  ...wholesalers,
  ...malls,
}
